import DeliveryPartnerService from '../../services/DeliveryPartnerService';
import deliveryPartnerUseCase from './deliveryPartnerUseCase';

const deliveryPartnerFactory = deliveryPartnerUseCase({
  DeliveryPartnerService: DeliveryPartnerService(),
});

export default deliveryPartnerFactory;
